module.exports = __webpack_public_path__ + "img/supplies_white.2d8a866f.svg";